module.exports = __webpack_public_path__ + "0f53a30dfada0d0982b09422ed17b074.svg";